import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DialogMessage, DialogMessageMarkAsReadModel } from '../../../../common/model/dialog';
import { SenderTypeToString } from '../../../../common/model/const/enum';
import { ChatService } from '../../../../common/service/chat-service';
import { MessageService } from '../../../../core/service/message.service';
import { map, take } from 'rxjs';

@Component({
    selector: 'app-chat-message',
    templateUrl: './chat-message.component.html',
    styleUrls: ['./chat-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatMessageComponent {
  constructor(
    private _chatService: ChatService,
    private _messageService: MessageService
  ) {}

  @Input() index: number;
  @Input() dialogMessage: DialogMessage;
  @Input({ required: true }) dialogEndpoint!: string;
  @Input() isTenantInvolved: boolean = true;
  previewImageUrl: string;
  @ViewChild('readCheckbox') readCheckbox: ElementRef;
  @Output() delete = new EventEmitter<string>();
  attachmentsRerenderFlag: boolean = true;

  get senderName(): string {
    if (this.dialogMessage.senderUserContact) {
      return this.dialogMessage.senderUserContact.name;
    }

    if (this.dialogMessage.senderUser) {
      return this.dialogMessage.senderUser.personName ? this.dialogMessage.senderUser.personName : this.dialogMessage.senderUser.name;
    }

    return 'N/A';
  }

  get readBy(): string {
    if (this.dialogMessage.readByUserContact) {
      return this.dialogMessage.readByUserContact.name;
    }

    if (this.dialogMessage.readByUser) {
      return this.dialogMessage.readByUser.personName ? this.dialogMessage.readByUser.personName : this.dialogMessage.readByUser.name;
    }

    return 'N/A';
  }

  get senderTypeString(): string {
    return SenderTypeToString(this.dialogMessage.senderKind);
  }

  get hoursString(): string {
    if (this.dialogMessage.sendTime) {
      const hours = this.dialogMessage.sendTime.getHours();
      const minutes = this.dialogMessage.sendTime.getMinutes();

      return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    }

    return '##:##';
  }

  get dateString(): string {
    if (this.dialogMessage.readTime) {
      return this._formatChatDate(this.dialogMessage.readTime);
    }

    return '##:##';
  }

  @Input() messageCheckAsReadBlocked: boolean = false;
  messageCheckAsUnreadBlocked: boolean = false;

  checkMessageAsRead() {
    this.messageCheckAsReadBlocked = true;

    setTimeout(() => {
      const model = new DialogMessageMarkAsReadModel();
      model.id = this.dialogMessage.id;

      this._chatService.markAsRead(model, this.dialogEndpoint).subscribe(x => {
        this._fillMessageModel(x);
        this.messageCheckAsReadBlocked = false;
      });
    }, 200);
  }

  checkMessageAsUnread() {
    this.messageCheckAsUnreadBlocked = true;

    setTimeout(() => {
      const model = new DialogMessageMarkAsReadModel();
      model.id = this.dialogMessage.id;

      this._chatService.markAsUnread(model, this.dialogEndpoint).subscribe(x => {
        this._fillMessageModel(x);
        this.messageCheckAsUnreadBlocked = false;
      });
    }, 200);
  }

  rerenderAttachments() {
    setTimeout(() => (this.attachmentsRerenderFlag = false));
    setTimeout(() => (this.attachmentsRerenderFlag = true));
  }

  private _fillMessageModel(source: DialogMessage) {
    this.dialogMessage.isRead = source.isRead;
    this.dialogMessage.canMarkAsUnread = source.canMarkAsUnread;
    this.dialogMessage.canMarkAsRead = source.canMarkAsRead;
    this.dialogMessage.readTime = source.readTime;
    this.dialogMessage.readerKind = source.readerKind;
    this.dialogMessage.readByUser = source.readByUser;
    this.dialogMessage.readByUserContact = source.readByUserContact;
  }

  deleteMessage() {
    this._messageService
      .showDialog('CHAT.MESSAGE.DELETE_MESSAGE')
      .pipe(
        take(1),
        map(res => {
          if (res) {
            this._chatService.deleteMessage(this.dialogMessage.id, this.dialogEndpoint).subscribe(x => {
              this.delete.emit(this.dialogMessage.id);
            });
          }
        })
      )
      .subscribe();
  }

  private _formatChatDate(date: Date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
}
